"use strict";

var __awaiter = this && this.__awaiter || function (thisArg, _arguments, P, generator) {
  function adopt(value) {
    return value instanceof P ? value : new P(function (resolve) {
      resolve(value);
    });
  }

  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }

    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }

    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }

    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};

var __generator = this && this.__generator || function (thisArg, body) {
  var _ = {
    label: 0,
    sent: function sent() {
      if (t[0] & 1) throw t[1];
      return t[1];
    },
    trys: [],
    ops: []
  },
      f,
      y,
      t,
      g;
  return g = {
    next: verb(0),
    "throw": verb(1),
    "return": verb(2)
  }, typeof Symbol === "function" && (g[Symbol.iterator] = function () {
    return this;
  }), g;

  function verb(n) {
    return function (v) {
      return step([n, v]);
    };
  }

  function step(op) {
    if (f) throw new TypeError("Generator is already executing.");

    while (_) {
      try {
        if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
        if (y = 0, t) op = [op[0] & 2, t.value];

        switch (op[0]) {
          case 0:
          case 1:
            t = op;
            break;

          case 4:
            _.label++;
            return {
              value: op[1],
              done: false
            };

          case 5:
            _.label++;
            y = op[1];
            op = [0];
            continue;

          case 7:
            op = _.ops.pop();

            _.trys.pop();

            continue;

          default:
            if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
              _ = 0;
              continue;
            }

            if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
              _.label = op[1];
              break;
            }

            if (op[0] === 6 && _.label < t[1]) {
              _.label = t[1];
              t = op;
              break;
            }

            if (t && _.label < t[2]) {
              _.label = t[2];

              _.ops.push(op);

              break;
            }

            if (t[2]) _.ops.pop();

            _.trys.pop();

            continue;
        }

        op = body.call(thisArg, _);
      } catch (e) {
        op = [6, e];
        y = 0;
      } finally {
        f = t = 0;
      }
    }

    if (op[0] & 5) throw op[1];
    return {
      value: op[0] ? op[1] : void 0,
      done: true
    };
  }
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var prism_1 = require("../prism");

var detect_languages_1 = require("./detect-languages");
/**
 * Async function that applies prism highlighting to a given element and its children.
 * Returns a promise that is resolved when the operation is complete.
 *
 * @param {Object} element The target DOM element
 * @param {Object} options Options object
 * @param {Boolean} [options.parallel] When multiple languages were detected: Whether to load and apply all languages in parallel
 * @param {Boolean} [options.async] Whether to use Web Workers for async highlighting. See https://prismjs.com/extending.html#api
 * @param {Function} [options.onHighlight] Optional callback invoked after highlighting was applied on an element
 * @param {Function} [options.onHighlightError] Optional callback invoked after an error happen during highlighting an element
 */


function applyPrism(element, options) {
  return __awaiter(this, void 0, void 0, function () {
    var languageMap, languages, isMounted, run, _i, languages_1, language;

    return __generator(this, function (_a) {
      switch (_a.label) {
        case 0:
          languageMap = detect_languages_1.getLanguageMap(element);
          languages = Object.keys(languageMap);

          isMounted = function isMounted() {
            return !!element;
          };

          run = function run(language) {
            return highlight(languageMap[language], language, options, isMounted);
          };

          if (!options.parallel) return [3
          /*break*/
          , 2];
          return [4
          /*yield*/
          , Promise.all(languages.map(function (language) {
            return run(language);
          }))];

        case 1:
          _a.sent();

          return [3
          /*break*/
          , 6];

        case 2:
          _i = 0, languages_1 = languages;
          _a.label = 3;

        case 3:
          if (!(_i < languages_1.length)) return [3
          /*break*/
          , 6];
          language = languages_1[_i];
          return [4
          /*yield*/
          , run(language)];

        case 4:
          _a.sent();

          _a.label = 5;

        case 5:
          _i++;
          return [3
          /*break*/
          , 3];

        case 6:
          return [2
          /*return*/
          ];
      }
    });
  });
}

exports.applyPrism = applyPrism;

function highlight(element, language, options, isMounted) {
  var _a, _b;

  return __awaiter(this, void 0, void 0, function () {
    var error_1, elements;
    return __generator(this, function (_c) {
      switch (_c.label) {
        case 0:
          if (!isMounted()) {
            return [2
            /*return*/
            ];
          }

          if (typeof options.providers.languages[language] !== 'function') {
            process.env.NODE_ENV !== 'production' && console.warn('[apply-prism] provider not found:', language);
            return [2
            /*return*/
            ];
          }

          if (!!options.providers.usePrismAutoload) return [3
          /*break*/
          , 4];
          _c.label = 1;

        case 1:
          _c.trys.push([1, 3,, 4]);

          return [4
          /*yield*/
          , options.providers.languages[language]()];

        case 2:
          _c.sent();

          return [3
          /*break*/
          , 4];

        case 3:
          error_1 = _c.sent();
          process.env.NODE_ENV !== 'production' && console.error('[apply-prism] failed loading:', language, error_1);
          (_b = (_a = options).onHighlightError) === null || _b === void 0 ? void 0 : _b.call(_a, error_1);
          return [2
          /*return*/
          ];

        case 4:
          if (isMounted()) {
            elements = Array.isArray(element) ? element : [element];
            elements.forEach(function (element) {
              var _a, _b;

              try {
                prism_1.Prism.highlightElement(element, options.async, options.onHighlight);
              } catch (error) {
                process.env.NODE_ENV !== 'production' && console.error('[apply-prism] failed:', language, element, error);
                (_b = (_a = options).onHighlightError) === null || _b === void 0 ? void 0 : _b.call(_a, error);
              }
            });
          }

          return [2
          /*return*/
          ];
      }
    });
  });
}

exports.highlight = highlight;